import '../Common/css/polaris.css';

import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Common/css/common.css';
import 'jquery-ajax-transport-xdomainrequest';
import './Landing.css';




$(window).on('load', function () {
    if (navigator.userAgent.indexOf("MSIE 10") > -1) {
        document.body.classList.add("ie10");
    }

});




// WEBPACK FOOTER //
// ./UI/Landing.js